<template>
    <div class="matches">
        <div class="contenido">

            <v-container fluid class="py-0">
                <v-row  style="height: calc(100vh - 200px)" justify="center">
                    
                    <v-col cols="12" md="auto" style="width: 330px; background-color: #E4CFA6;" class="text-center py-0 px-0">


                        <div class="py-12 px-6" style="height: calc(100vh - 200px - 40px); overflow: auto;">


                            <span class="uppercase d-block">Mi pedido</span>
                            <v-avatar size="90" class="mt-6">
                                <v-img :src="'http://flordeazaharcms.actstudio.xyz/'+cart[0].producto.cover.path">
                                </v-img>
                            </v-avatar>

                            <span class="PTSerif d-block mt-6" style="font-size: 28px">{{cart[0].producto.name}}</span>

                            <span class="d-block">Cant. { {{cart[0].cantidad}} }</span>
                            <span class="d-block">${{cart[0].producto.precio}}.00 MX</span>



                            <template v-if="cart.length > 0">
                                <hr class="my-3">

                                <div class="my-3" v-for="(item,n) in cart" :key="'item-'+n">
                                    <template v-if="n>0">
                                        <span class="PTSerif d-block mx-auto" style="font-size: 14px">{{item.producto.name}} ( {{item.cantidad}} )</span>
                                        <span class="Robtoto d-block mx-auto">${{item.producto.precio}}.00 MX</span>
                                    </template>
                                </div>

                            </template>

                        </div>

                        <v-btn height="40px" block>Boton</v-btn>

                    </v-col>
                    <v-col cols="12" md="auto" class="py-0 px-0" style="background-color: #FFFFFF; max-width: calc(100% - 330px); position: relative;">

                        <span class="cerrar" @click="cerrar()">
                            <v-icon>mdi-close</v-icon>
                        </span>
                        <div class="px-12" style="height: calc(100vh - 200px - 40px); overflow: auto;">

                            <div class="d-flex" style="height: 100%; width: 100%; align-items: center;">
                                <v-container fluid>

                                    <v-row>
                                        <v-col>
                                            <span class="PTSerif bold d-block" style="font-size: 28px">Flores y algo
                                                más</span>
                                            <span class="Roboto d-block" style="font-size: 12px;">¿Te gustaría añadir algún
                                                complemento a tu pedido?</span>
                                        </v-col>
                                    </v-row>

                                    <v-row justify="center" class="d-none d-md-flex">
                                        <v-col class="text-center px-10" cols="4" v-for="(producto,n) in relacionados" :key="n"
                                            style="position:relative;">
                                            <v-icon class="heart-position" color="#979797">mdi-heart-outline</v-icon>
                                            <v-img :src="'https://flordeazaharcms.actstudio.xyz/'+producto.cover.path"
                                                width="100%" contain class="d-block mx-auto" aspect-ratio="1"></v-img>
                                            <span class="d-block PTSerif bold mt-4 mb-1"
                                                style="font-size: 14px">{{producto.name}}</span>
                                            <span class="d-block mb-4" style="font-size: 20px">${{producto.precio}}
                                                MXN</span>
                                            <v-btn rounded elevation="0" dark color="#B4613D" class="px-8" @click="agregar_al_carrito(producto)">
                                                <span style="font-size: 14px">AGREGAR</span>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </div>

                        </div>

                        <router-link to="/cesta">
                            <v-btn height="40px" block color="#56604D" dark>Finalizar Pedido</v-btn>
                        </router-link>

                    </v-col>
                </v-row>
            </v-container>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            url: String
        },
        data() {
            return {
                producto: null,
                cart: [],
                relacionados: null
            }
        },
        methods: {
            cerrar: function () {
                this.$emit("update");
            },
            has_text: function (text) {
                return String(text).length > 0;
            },
            agregar_al_carrito: function (productooo) {
                /*
                  Sí un producto se agrega al carrito, se tiene que revisar si la variable de sesión 'cart' existe, hay dos escenarios principales que podrían suceder:

                  1. Si ya existe la variable 'cart' en sesión pueden existir también dos escenarios que podrían suceder:

                    a) Si el producto que se está agregando ya existe en la variable de sesión cart, hay que aumentar la cantidad a la variable de sessión, no crear un nuevo registro duplicado.

                    b)Si el producto que se está agregando no existe, hay que crear un nuevo registro en la variable de sessión 'cart' con la información del producto.

                  2. Si no existe la variable 'cart' en sesión, se tiene que crear esa variable con los datos del producto organizado en un array 
                */
                if (this.$session.has("cart")) {
                    // Revisión escenario 1
                    var auxiliar = this.$session.get("cart");

                    if (
                        auxiliar.find(producto => producto.producto._id == productooo._id)
                    ) {
                        // Revisión 1.a
                        let index = auxiliar.findIndex(
                            producto => producto.producto._id == productooo._id
                        );

                        auxiliar[index].cantidad =
                            parseInt(auxiliar[index].cantidad) + 1;
                    } else {
                        // Revision 1.b
                        var carrito_auxiliar = {
                            producto: productooo,
                            cantidad: 1
                        };

                        auxiliar.push(carrito_auxiliar);
                    }

                    this.$session.set("cart", auxiliar);
                } else {
                    // Revisión escenario 2
                    var carrito_auxiliar = [{
                        producto: productooo,
                        cantidad: 1
                    }];

                    this.$session.set("cart", carrito_auxiliar);
                }

                this.$emit("updated");
            },
            restar_cantidad: function () {
                if (this.cantidad >= 2) {
                    this.cantidad--;
                }
            },
            sumar_cantidad: function () {
                this.cantidad++;
            },
            borrar_carrito: function () {
                this.$session.remove("cart");
            }
        },
        created: function () {
            console.log(this.url);

            var aux = this;
            fetch(
                    "https://flordeazaharcms.actstudio.xyz/api/collections/get/Productos?token=bd38a532024ddfd195a5fdefd8eb98", {
                        method: "post",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            filter: {
                                url: this.$route.params.producto
                            },
                            populate: 2 // resolve linked collection items
                        })
                    }
                )
                .then(res => res.json())
                .then(res => (this.producto = res.entries[0]))
                .then(function (response) {


                    fetch(
                            "https://flordeazaharcms.actstudio.xyz/api/collections/get/Productos?token=bd38a532024ddfd195a5fdefd8eb98", {
                                method: "post",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    filter: {

                                    },
                                    populate: 2, // resolve linked collection items
                                    limit: 3
                                })
                            }
                        )
                        .then(respuesta => respuesta.json())
                        .then(respuesta => (aux.relacionados = respuesta.entries))
                })


            this.cart = this.$session.get('cart');
        },
    };
</script>